/* D'Todo Camelot · cam-pricing.js · copia del motor V146-1 de San Antonio (sa-samita-catalog.js).
   Lee las reglas de Samita que la app publica en la tienda (window.Samita.Wholesale.volumePricing)
   y calcula el precio por cantidad igual que el carrito. Samita sigue siendo la autoridad en el checkout.
   Solo incluye el motor y la API que usa Camelita; no toca las tarjetas del catálogo.
   Fuera del bloque MOTOR: agrupaciones «variant» y «within_each_group» y escalas de precio fijo de Camelot (verificadas en el carrito).
   El bloque "MOTOR" no se edita aquí: si cambia en San Antonio, se vuelve a copiar. */
(function(){
"use strict";
/* ===== MOTOR V146-1 (copia literal de Code.gs) ===== */
function saNormalizarReglaV141_(id,r,bridge){
 if(!/^\d{1,20}$/.test(String(id)))throw new Error('ID de regla inválido: '+id);
 r=r||{};
 const ids=x=>Array.isArray(x)?[...new Set(x.map(v=>String(v&&typeof v==='object'?(v.id||v.variant_id||''):v)).filter(y=>/^\d{1,22}$/.test(y)))].sort():[];
 const num=x=>{if(x===null||x===undefined||String(x).trim()==='')return null;const n=Number(x);return Number.isFinite(n)&&n>=0&&n<=10000000?n:null;};
 // Un valor vacío se conserva como null para que el motor lo marque (no se descarta en silencio).
 const grp=a=>(Array.isArray(a)?a:[]).slice(0,12).map(g=>({name:String(g&&g.name||'').slice(0,50),type:String(g&&g.type||'').slice(0,40),value:num(g&&g.value)})).filter(g=>g.name||g.type);
 const monto=t=>!!t&&t.from_amount!==null&&t.from_amount!==undefined&&String(t.from_amount)!=='';
 const small=x=>{try{const t=JSON.stringify(x===undefined?null:x);return t.length<=4000?JSON.parse(t):'DEMASIADO_GRANDE';}catch(e){return null;}};
 const tiers=(Array.isArray(r.discounts)?r.discounts:[]).slice(0,60).map(t=>({from_qty:num(t.from_qty!=null&&t.from_qty!==''?t.from_qty:t.qty),to_qty:num(t.to_qty),type:String(t.type||'').slice(0,40),value:num(t.value),por_monto:monto(t)}))
  .filter(t=>t.from_qty>=1&&t.value!==null).sort((a,b)=>a.from_qty-b.from_qty);
 const special=(Array.isArray(r.special)?r.special:[]).slice(0,8000).map(s=>{
  const vt=(Array.isArray(s.variant_tiers)?s.variant_tiers:[]).slice(0,6000).map(v=>({vid:String(v.vid||v.id||''),from_qty:num(v.from_qty),to_qty:num(v.to_qty),discount_groups:grp(v.discount_groups)}))
   .filter(v=>/^\d{1,22}$/.test(v.vid)&&v.from_qty>=1).sort((a,b)=>a.vid.localeCompare(b.vid)||a.from_qty-b.from_qty);
  return {id:String(s.id||''),from_qty:num(s.from_qty),to_qty:num(s.to_qty),variant_pricing:!!s.variant_pricing,variants:ids(s.variants),variant_tiers:vt,discount_groups:grp(s.discount_groups),por_monto:monto(s)};
 }).filter(s=>/^\d{1,22}$/.test(s.id)&&s.from_qty>=1);
 const meta=r.meta&&typeof r.meta==='object'?small(r.meta):null;
 const grouping=String(r.grouping||(meta&&meta.discount_types&&meta.discount_types.type)||'').slice(0,40);
 const v146=String(bridge||'')==='V146';
 return {
  type:String(r.type||'').slice(0,32),rule_type:String(r.rule_type||'').slice(0,32),
  manual_ids:ids(r.manual_ids),collection_ids:ids(r.collection_ids),manual_variant_ids:ids(r.manual_variant_ids),
  apply_for_variants:r.apply_for_variants===true?true:(r.apply_for_variants===false?false:null),
  manual_tags:Array.isArray(r.manual_tags)?r.manual_tags.map(x=>String(x).slice(0,60)).slice(0,50):[],
  volume_type:String(r.volume_type||'').slice(0,32),pricing_source:String(r.pricing_source||'').slice(0,32),grouping:grouping,
  discount_for_variants:small(r.discount_for_variants===undefined?null:r.discount_for_variants),
  discounts:tiers,special:special,detalle_completo:v146,meta:v146?null:meta
 };
}
function saIdV145_(x){return String(x==null?'':x).split('/').pop().trim();}
function saNumV145_(x){if(x===null||x===undefined||String(x).trim()==='')return null;const n=Number(String(x).replace(',','.'));return Number.isFinite(n)?n:null;}
function saR2V145_(x){return Math.round((Number(x)+Number.EPSILON)*100)/100;}
function saTipoV145_(t){
 t=String(t||'').toLowerCase().trim();
 if(t==='percent'||t==='percentage'||t==='porcentaje')return 'percent';
 // En los precios especiales de Samita "fixed-amount" es el precio final por unidad
 // (el export lo muestra como "fixed" y baja al subir la cantidad: 0.20 → 0.15).
 if(t==='fixed'||t==='fixed-price'||t==='fixed_price'||t==='fixed-amount'||t==='fixed_amount'||t==='precio_fijo')return 'fixed';
 return t||'';
}
function saPrecioTierV145_(base,tipo,v){
 v=Number(v);if(!Number.isFinite(v))return null;
 if(tipo==='percent')return v>=0&&v<100?base*(1-v/100):null;
 if(tipo==='fixed')return v>0?v:null;
 return null;
}
function saCoincideReglaV145_(rule,pid,cols){
 const t=String(rule&&rule.type||'').toLowerCase();
 if(t==='products')return (rule.manual_ids||[]).map(String).indexOf(pid)>=0;
 if(t==='collections')return !!cols&&(rule.collection_ids||[]).some(c=>cols.has(String(c)));
 if(t==='all'||t==='all_products'||t==='all-products')return true;
 return false;
}
function saEscalasReglaV145_(rule,ruleId,pid,vid,base,avisos,pend){
 pend=pend||new Set();
 const esp=[],gen=[];let enEspecial=false,varNoListada=false;
 const add=(arr,from,to,g,source)=>{
  const tipo=saTipoV145_(g.type),pr=saPrecioTierV145_(base,tipo,g.value);
  if(g.value===null||g.value===undefined||!Number.isFinite(Number(g.value))){pend.add('VALOR_VACIO_EN_SAMITA');return;}
  if(pr===null){pend.add('TIPO_DESCONOCIDO');return;}
  if(source==='especial'&&tipo==='percent')pend.add('ESPECIAL_PORCENTAJE_POR_VERIFICAR');
  if(source==='general'&&tipo==='fixed')pend.add('FIJO_EN_REGLA_GENERAL_POR_VERIFICAR');
  arr.push({qty:Number(from),to:to===null||to===undefined?null:Number(to),price:saR2V145_(pr),exact:pr,type:tipo,value:Number(g.value),rule:ruleId,source:source});
 };
 (rule.special||[]).forEach(s=>{
  if(String(s.id)!==pid)return;
  enEspecial=true;
  if(s.por_monto)pend.add('ESCALA_POR_MONTO_POR_VERIFICAR');
  if(s.variant_pricing){
   if((s.variant_tiers||[]).length){
    const mias=s.variant_tiers.filter(v=>v.vid===vid);
    if(!mias.length){varNoListada=true;return;}
    mias.forEach(v=>{const g=saGrupoPrecioV146_(v.discount_groups);if(!g){pend.add('GRUPOS_MULTIPLES_SIN_ALL');return;}add(esp,v.from_qty,v.to_qty,g,'especial');});
   }else{
    pend.add('DETALLE_VARIANTES_FALTANTE');
    if((s.variants||[]).map(String).indexOf(vid)<0){varNoListada=true;return;}
    const g=saGrupoPrecioV146_(s.discount_groups);if(g)add(esp,s.from_qty,s.to_qty,g,'especial');
   }
   return;
  }
  const g=saGrupoPrecioV146_(s.discount_groups);
  if(!g){if((s.discount_groups||[]).length>1)pend.add('GRUPOS_MULTIPLES_SIN_ALL');return;}
  add(esp,s.from_qty,s.to_qty,g,'especial');
 });
 // Verificado en el carrito (3 casos): si el producto tiene precio por variante y esta
 // variante no está en la lista, Samita NO le aplica ningún descuento (ni el general).
 if(enEspecial&&varNoListada&&!esp.length){avisos.add('VARIANTE_SIN_DESCUENTO_EN_SAMITA');return {especial:[],general:[],sin_descuento:true};}
 (rule.discounts||[]).forEach(t=>{if(t.por_monto)pend.add('ESCALA_POR_MONTO_POR_VERIFICAR');add(gen,t.from_qty,t.to_qty,{type:t.type||rule.volume_type,value:t.value},'general');});
 const limpiar=arr=>{const m={};arr.forEach(t=>{const o=m[t.qty];if(!o){m[t.qty]=t;return;}if(Math.abs(o.exact-t.exact)>1e-9)pend.add('ESCALA_DUPLICADA');});return Object.keys(m).map(k=>m[k]).sort((a,b)=>a.qty-b.qty);};
 const e=limpiar(esp),g=limpiar(gen);
 [e,g].forEach(arr=>{for(let i=0;i<arr.length-1;i++)if(arr[i].to!==null&&arr[i].to+1<arr[i+1].qty){avisos.add('HUECO_EN_ESCALAS');break;}});
 return {especial:e,general:g};
}
function saMotorSamitaV145_(rules,prod){
 const pid=saIdV145_(prod.pid),vid=saIdV145_(prod.vid),base=Number(prod.precio);
 const out={ok:true,pid:pid,vid:vid,precio_normal:base,reglas:[],regla:null,escalas:[],origen:'SIN_REGLA',agrupacion:'',conflicto:false,reglas_conflicto:[],avisos:[],pendientes:[],verificacion:'VERIFICADO'};
 if(!(base>0)){out.ok=false;out.error='PRECIO_UNITARIO_INVALIDO';out.verificacion='PENDIENTE';out.pendientes=['PRECIO_UNITARIO_INVALIDO'];return out;}
 const avisos=new Set(),pend=new Set(),porRegla={};
 Object.keys(rules||{}).sort((a,b)=>Number(a)-Number(b)).forEach(id=>{
  const r=rules[id];if(!r||!saCoincideReglaV145_(r,pid,prod.colecciones))return;
  // Regla por productos limitada a variantes concretas.
  if(String(r.type).toLowerCase()==='products'&&r.apply_for_variants===true&&(r.manual_variant_ids||[]).length&&r.manual_variant_ids.indexOf(vid)<0)return;
  out.reglas.push(id);
  if(r.detalle_completo===false)pend.add('LECTURA_SIN_DETALLE_V146');
  if(r.pricing_source&&r.pricing_source!=='PRICE')pend.add('FUENTE_DE_PRECIO_POR_VERIFICAR');
  if(Array.isArray(r.discount_for_variants)&&r.discount_for_variants.length)pend.add('FILTRO_VARIANTES_POR_VERIFICAR');
  if(String(r.type).toLowerCase()!=='products'&&r.apply_for_variants===true&&(r.manual_variant_ids||[]).length)pend.add('FILTRO_VARIANTES_POR_VERIFICAR');
  const e=saEscalasReglaV145_(r,id,pid,vid,base,avisos,pend);
  if(e.especial.length&&e.general.length){avisos.add('ESPECIAL_REEMPLAZA_GENERAL');if(e.especial[0].qty>e.general[0].qty)pend.add('ESPECIAL_EMPIEZA_DESPUES_POR_VERIFICAR');}
  if(e.sin_descuento)return;
  const sched=e.especial.length?e.especial:e.general;
  const g=String(r.grouping||'');
  if(sched.length)porRegla[id]={sched:sched,origen:e.especial.length?'ESPECIAL':'GENERAL',agr:g};
 });
 const ids=Object.keys(porRegla);
 if(out.reglas.length&&!ids.length&&!avisos.has('VARIANTE_SIN_DESCUENTO_EN_SAMITA'))avisos.add('REGLA_SIN_ESCALAS');
 if(ids.length){
  const firma=x=>JSON.stringify(x.sched.map(t=>[t.qty,t.to,t.price]));
  const f0=firma(porRegla[ids[0]]);
  if(ids.length>1&&ids.some(i=>firma(porRegla[i])!==f0)){
   out.conflicto=true;out.reglas_conflicto=ids;out.origen='CONFLICTO';pend.add('REGLAS_SUPERPUESTAS_POR_VERIFICAR');
   ids.forEach(i=>porRegla[i].sched.forEach(t=>out.escalas.push(t)));out.escalas.sort((a,b)=>a.qty-b.qty||a.price-b.price);
  }else{
   if(ids.length>1)avisos.add('VARIAS_REGLAS_MISMO_PRECIO');
   const el=porRegla[ids[0]];out.regla=ids[0];out.escalas=el.sched;out.origen=el.origen;
   out.agrupacion=el.agr==='across_group'?'across_group':el.agr;
   if(!el.agr)pend.add('AGRUPACION_DESCONOCIDA');
   else if(el.agr!=='across_group')pend.add('AGRUPACION_POR_VERIFICAR');
  }
 }
 out.avisos=[...avisos];out.pendientes=[...pend];out.verificacion=pend.size?'PENDIENTE':'VERIFICADO';
 return out;
}
function saPrecioCantidadV145_(res,qty,qtyProducto){
 qty=Number(qty);
 if(!res.ok)return {ok:false,error:res.error,verificacion:'PENDIENTE'};
 if(!Number.isSafeInteger(qty)||qty<1)return {ok:false,error:'CANTIDAD_INVALIDA'};
 if(res.conflicto)return {ok:false,error:'CONFLICTO_REGLAS',reglas:res.reglas_conflicto,verificacion:'PENDIENTE'};
 const q=res.agrupacion==='across_group'&&Number(qtyProducto)>qty?Number(qtyProducto):qty;
 const sel=saTierParaV146_(res.escalas,q),t=sel.tier,pend=res.pendientes.slice();
 // Verificado en el carrito (4 casos): una cantidad en un hueco entre escalas no recibe descuento.
 const base=res.precio_normal,baseC=Math.round(base*100);
 let unitExact=base,lineC=baseC*qty;
 if(t){
  unitExact=Math.min(t.exact,base);
  // Checkout de Samita: descuento por línea truncado al centavo (verificado).
  if(t.type==='percent')lineC=baseC*qty-Math.floor(baseC*qty*t.value/100+1e-7);
  else lineC=Math.round(Math.min(t.exact,base)*100)*qty;
 }
 const unit=saR2V145_(unitExact),sig=res.escalas.find(x=>x.qty>q&&x.price<unit)||null;
 const verif=pend.length?'PENDIENTE':'VERIFICADO';
 return {ok:true,unitario:unit,cantidad:qty,cantidad_evaluada:q,total:lineC/100,total_lista:saR2V145_(unit*qty),aplicado:!!t&&unitExact<base,regla:t?t.rule:null,desde:t?t.qty:1,hasta:t?t.to:null,origen:t?t.source:'precio_normal',
  siguiente_escala:sig?{desde:sig.qty,unitario:sig.price,faltan:sig.qty-q}:null,verificacion:verif,pendientes:pend,apto_cotizar:verif==='VERIFICADO'};
}
function saGrupoPrecioV146_(gs){gs=gs||[];return gs.find(x=>x.name==='all')||(gs.length===1?gs[0]:null);}
function saTierParaV146_(escalas,q){
 let t=null,hueco=false;
 escalas.forEach(x=>{if(x.qty<=q){if(x.to===null||x.to===undefined||q<=x.to){if(!t||x.qty>t.qty)t=x;}else hueco=true;}});
 if(t)hueco=false;
 return {tier:t,hueco:hueco&&!t};
}
/* ===== FIN MOTOR ===== */

/* ---- Lectura de window.Samita.Wholesale.volumePricing (idéntica al puente V146 del sistema) ---- */
function _vid(v){return String(v&&typeof v==='object'?(v.id||v.variant_id||''):v);}
function _ids(a){return Array.isArray(a)?a.map(_vid).filter(function(x){return /^\d+$/.test(x);}):[];}
function _n(x){return x===null||x===undefined||x===''?null:Number(x);}
function _grp(a){return (Array.isArray(a)?a:[]).map(function(g){var v=g&&g.value;return {name:String(g&&g.name||''),type:String(g&&g.type||''),value:v===null||v===undefined||v===''?null:Number(v)};});}
function _small(x){try{var t=JSON.stringify(x===undefined?null:x);return t.length<=3000?JSON.parse(t):'DEMASIADO_GRANDE';}catch(e){return null;}}
function leerReglas(all){
  var out={};
  Object.keys(all||{}).slice(0,300).forEach(function(id){if(!/^\d+$/.test(id))return;
    var r=all[id]||{},cf=r.configs||{},pc=r.product_configs||{},a=pc.apply_product||{},m=a.manual||{},v=cf.volume_discount||{};
    var raw={rule_type:String(r.type||''),type:String(a.type||''),manual_ids:_ids(m.ids),manual_variant_ids:_ids(m.variants).concat(_ids(m.apply_variants)),apply_for_variants:m.apply_for_variants===true,manual_tags:(Array.isArray(m.tags)?m.tags:[]).map(String),
      collection_ids:_ids(a.collections&&a.collections.ids),grouping:String(cf.discount_types&&cf.discount_types.type||''),volume_type:String(v.type||''),pricing_source:String(v.pricing_source||''),discount_for_variants:_small(cf.discount_for_variants),
      discounts:(Array.isArray(v.discounts)?v.discounts:[]).map(function(t){return {from_qty:_n(t.from_qty!=null?t.from_qty:t.qty),to_qty:_n(t.to_qty),type:String(t.type||''),value:Number(t.value),from_amount:t.from_amount==null?null:t.from_amount};}),
      special:(Array.isArray(cf.custom_price_list)?cf.custom_price_list:[]).map(function(e){var vt=[];
        if(e.variant_pricing&&Array.isArray(e.variants))e.variants.forEach(function(x){if(x&&typeof x==='object')vt.push({vid:_vid(x),from_qty:_n(x.from_qty),to_qty:_n(x.to_qty),discount_groups:_grp(x.discount_groups)});});
        return {id:String(e.id||''),from_qty:_n(e.from_qty),to_qty:_n(e.to_qty),variant_pricing:!!e.variant_pricing,variants:_ids(e.variants),variant_tiers:vt,discount_groups:_grp(e.discount_groups),from_amount:e.from_amount==null?null:e.from_amount};})};
    try{out[id]=saNormalizarReglaV141_(id,raw,'V146');}catch(err){}
  });
  return out;
}
var _cache={src:null,n:0,rules:null};
function reglas(){
  var all=window.Samita&&window.Samita.Wholesale&&window.Samita.Wholesale.volumePricing;
  var n=all?Object.keys(all).length:0;
  if(!n)return null;
  if(_cache.src!==all||_cache.n!==n){_cache.src=all;_cache.n=n;_cache.rules=leerReglas(all);}
  return _cache.rules;
}
function motor(productId,variantId,unitPrice,collectionIds){
  var R=reglas();if(!R)return null;
  var r=saMotorSamitaV145_(R,{pid:String(productId),vid:String(variantId),precio:Number(unitPrice),colecciones:new Set((collectionIds||[]).map(String))});
  // Camelot usa agrupaciones que San Antonio no tiene. Verificadas en el carrito real (24-oct-2026):
  // «variant»: cada variante cuenta sola (2 Carbonara + 1 Pollo Picante = sin descuento; 3 Carbonara = $6.00 c/u).
  // «within_each_group»: suma todos los productos de la misma regla (1 Lingo Leap + 1 OLLY = precio de 2 u en ambos).
  // Tiras Prodigy (24-oct-2026): escalas generales de precio fijo cobradas igual que el motor (solo tiras 2/4/6 u, con lancetas 2/3 u).
  // «discount_for_variants» con todos los valores vacíos no filtra nada (mismas pruebas).
  if(r){
    var quitar={'FIJO_EN_REGLA_GENERAL_POR_VERIFICAR':1};
    if(r.agrupacion==='variant'||r.agrupacion==='within_each_group')quitar.AGRUPACION_POR_VERIFICAR=1;
    if(r.regla&&dfvSinValores(R[r.regla]&&R[r.regla].discount_for_variants))quitar.FILTRO_VARIANTES_POR_VERIFICAR=1;
    r.pendientes=r.pendientes.filter(function(x){return !quitar[x];});
    r.verificacion=r.pendientes.length?'PENDIENTE':'VERIFICADO';
  }
  return r;
}
function dfvSinValores(d){
  if(!Array.isArray(d))return d==null;
  var vacio=function(gs){return (gs||[]).every(function(g){return g==null||g.value===null||g.value===undefined||g.value==='';});};
  return d.every(function(e){return e&&vacio(e.discount_groups)&&(e.variants||[]).every(function(v){return vacio(v&&v.discount_groups);});});
}
// Unidades con las que Samita evalúa la escala de una línea, según la agrupación de su regla.
function claveGrupo(r,l){
  if(!r||!r.regla)return 'V'+l.variantId;
  if(r.agrupacion==='within_each_group')return 'R'+r.regla;
  if(r.agrupacion==='across_group')return 'P'+l.productId;
  return 'V'+l.variantId;
}
function precioLinea(r,qty,unidadesGrupo){
  // saPrecioCantidadV145_ solo usa las unidades del grupo con across_group; within_each_group suma igual, pero por regla.
  var rr=r.agrupacion==='within_each_group'?Object.assign({},r,{agrupacion:'across_group'}):r;
  return saPrecioCantidadV145_(rr,qty,unidadesGrupo);
}
function salida(p,q){
  return {unit:p.unitario,quantity:q,total:p.total,totalPorUnidad:p.total_lista,applied:p.aplicado,min:p.desde,max:p.hasta,rule:p.regla,
    cantidadEvaluada:p.cantidad_evaluada,siguiente:p.siguiente_escala,verificacion:p.verificacion,pendientes:p.pendientes,apto:p.apto_cotizar};
}

/* ---- API pública: la usa Camelita ---- */
window.CamelotPricing={
  version:'V146-1-C2',
  // Solo lectura, para auditoría: reglas normalizadas que usa el motor.
  reglasNormalizadas:function(){var r=reglas();return r?JSON.parse(JSON.stringify(r)):null;},
  // Escalas que Samita aplicaría a esta variante (sin cantidad).
  escalas:function(productId,variantId,unitPrice,collectionIds){var r=motor(productId,variantId,unitPrice,collectionIds);return r?{reglas:r.reglas,regla:r.regla,escalas:r.escalas.map(function(t){return {desde:t.qty,hasta:t.to,unitario:t.price,tipo:t.type,valor:t.value,origen:t.source};}),conflicto:r.conflicto,verificacion:r.verificacion,pendientes:r.pendientes,avisos:r.avisos,agrupacion:r.agrupacion}:null;},
  // Cotiza UNA línea sola. otrasUnidadesDelGrupo = unidades de otras líneas que Samita suma con esta.
  quote:function(productId,variantId,unitPrice,collectionIds,qty,otrasUnidadesDelGrupo){
    var q=Number(qty),base=Number(unitPrice);
    if(!Number.isInteger(q)||q<1||!Number.isFinite(base)||base<=0)return null;
    var r=motor(productId,variantId,base,collectionIds);if(!r)return null;
    var p=precioLinea(r,q,q+Math.max(0,Number(otrasUnidadesDelGrupo)||0));
    if(!p.ok)return p.error==='CONFLICTO_REGLAS'?{conflict:p.reglas}:null;
    return salida(p,q);
  },
  // Cotiza un pedido completo: suma las unidades como lo hace Samita según la agrupación de cada regla.
  quoteLines:function(lineas){
    lineas=lineas||[];
    var rs=lineas.map(function(l){var q=Number(l.qty),b=Number(l.unitPrice);return Number.isInteger(q)&&q>=1&&Number.isFinite(b)&&b>0?motor(l.productId,l.variantId,b,l.collectionIds):null;});
    var suma={};lineas.forEach(function(l,i){var k=claveGrupo(rs[i],l);suma[k]=(suma[k]||0)+Number(l.qty||0);});
    var totalC=0,ok=true,apto=true;
    var out=lineas.map(function(l,i){var r=rs[i],q=Number(l.qty);
      if(!r){ok=false;apto=false;return {linea:l,error:'SIN_PRECIO'};}
      var p=precioLinea(r,q,suma[claveGrupo(r,l)]);
      if(!p.ok){ok=false;apto=false;return {linea:l,error:p.error==='CONFLICTO_REGLAS'?'CONFLICTO_REGLAS':'SIN_PRECIO'};}
      var x=salida(p,q);totalC+=Math.round(x.total*100);if(!x.apto)apto=false;return Object.assign({linea:l},x);});
    return {ok:ok,apto:apto,total:totalC/100,lineas:out};
  }
};
window.dispatchEvent(new CustomEvent('cam:pricing-ready',{detail:{version:'V146-1'}}));
})();
